import { z } from 'zod';
import { NameSchema } from "../../../../common/validators/value-objects.js";
export const BaseUserDTOSchema = z.object({
    id: z.string().uuid(),
    name: NameSchema,
    email: z.string().email(),
    emailVerified: z.boolean(),
    image: z.string().nullable(),
    userType: z.enum(['staff', 'tenant', 'integrator']),
    defaultCompanyId: z.string().uuid().nullable(),
    twoFactorEnabled: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    deletedAt: z.coerce.date().nullable(),
    isDeleted: z.boolean(),
});
//# sourceMappingURL=users.dto.js.map